const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M9.306 4.065a.75.75 0 0 0-.836.153l-.001.002L4.22 8.469A.751.751 0 0 0 5.282 9.53L8.25 6.564v6.184l.001.04v3.462A3.75 3.75 0 0 0 12 20h6.5a.75.75 0 0 0 0-1.5H12a2.25 2.25 0 0 1-2.25-2.25v-3.461l.001-.041V6.564l2.967 2.967A.751.751 0 1 0 13.78 8.47L9.531 4.22l-.034-.032z"/></svg>';
export {
  a as w
};
